export const SET_PRODUCT = 'SET_PRODUCT'
export const SET_SNACKBAR = 'SET_SNACKBAR'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_USER = 'SET_USER'
export const SET_GROUP = 'SET_GROUP'
export const SET_PROTOCOL = 'SET_PROTOCOL'
export const SET_SESSION = 'SET_SESSION'
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const SET_ORGANIZATION = 'SET_ORGANIZATION'
export const SET_MOBILEAPPVERSION = 'SET_MOBILEAPPVERSION'